import React from 'react';
import styled from 'styled-components';
import { buttonLikeStyles, buttonLikeTextStyles, ButtonVariant } from './buttonStyles';

interface StyleProps {
    variant?: ButtonVariant;
    className?: string;
    disabled?: boolean;
}

const SButton = styled.button<StyleProps>`
    ${buttonLikeStyles}
`;

const SParagraph = styled.p`
    ${buttonLikeTextStyles}
`;

interface Props extends StyleProps {
    title: string;
}

export const Button = ({ title, variant = 'filled', className, disabled }: Props) => (
    <SButton variant={variant} className={className} disabled={disabled}>
        <SParagraph>{title}</SParagraph>
    </SButton>
);
